"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiscountSelectionState = void 0;
var Discount_service_1 = __importDefault(require("@CommonFrontendBackend/Discount/Discount.service"));
var Types_1 = require("@CommonFrontendBackend/QuoteV2/Types");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var inversify_react_1 = require("inversify-react");
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var NumberInput_1 = __importDefault(require("NumberInput/NumberInput"));
var react_1 = __importStar(require("react"));
var QuoteTelemetry_1 = require("Telemetry/QuoteTelemetry");
var QuoteCurrencyFormatter_1 = __importDefault(require("Utils/QuoteCurrencyFormatter"));
var DiscountEditor_1 = require("../SettingsMenus/DiscountEditor/DiscountEditor");
var DiscountSelectionState;
(function (DiscountSelectionState) {
    DiscountSelectionState["None"] = "None";
    DiscountSelectionState["Saved"] = "Saved";
    DiscountSelectionState["Custom"] = "Custom";
})(DiscountSelectionState || (exports.DiscountSelectionState = DiscountSelectionState = {}));
var DiscountPanel = (function (_super) {
    __extends(DiscountPanel, _super);
    function DiscountPanel(props) {
        var _this = _super.call(this, props) || this;
        _this.handleDiscountSelectionChange = function (discountSelectionState) {
            var _a = _this.props, discountStore = _a.discountStore, telemetryHierarchy = _a.telemetryHierarchy;
            if (_this.discountSelectionState === discountSelectionState) {
                return;
            }
            _this.discountSelectionState = discountSelectionState;
            if (discountSelectionState === DiscountSelectionState.None) {
                _this.quoteTelemetry.trackDiscountApplied(telemetryHierarchy, "none");
            }
            if (discountSelectionState === DiscountSelectionState.None ||
                discountSelectionState === DiscountSelectionState.Saved) {
                discountStore.disableDiscount();
            }
            else if (discountSelectionState === DiscountSelectionState.Custom) {
                discountStore.setCustomDiscount(0, Types_1.DiscountType.Percent);
            }
        };
        var discountStore = _this.props.discountStore;
        if (!discountStore.enabled) {
            _this.discountSelectionState = DiscountSelectionState.None;
        }
        else if (discountStore.isSavedType()) {
            _this.discountSelectionState = DiscountSelectionState.Saved;
        }
        else {
            _this.discountSelectionState = DiscountSelectionState.Custom;
        }
        return _this;
    }
    DiscountPanel.prototype.renderSavedDiscounts = function () {
        var _this = this;
        var _a, _b;
        var _c = this.props, discountStore = _c.discountStore, telemetryHierarchy = _c.telemetryHierarchy;
        var savedDiscounts = this.discountService.getAllLiveDiscounts();
        var hasSavedDiscounts = savedDiscounts && savedDiscounts.length > 0;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            this.discountSelectionState === DiscountSelectionState.Saved && hasSavedDiscounts && (react_1.default.createElement(kaleidoscope_1.Dropdown, { name: (_b = (_a = savedDiscounts.find(function (discount) { return discount.id === discountStore.id; })) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : null, placeholder: "Select Discount", size: kaleidoscope_1.DropdownSize.Small }, savedDiscounts.map(function (discount) { return (react_1.default.createElement(kaleidoscope_1.DropdownItem, { key: discount.id, name: discount.name, selected: discount.id === discountStore.id, onSelect: function () {
                    discountStore.setSavedDiscount(discount.id);
                    _this.quoteTelemetry.trackDiscountApplied(telemetryHierarchy, "saved");
                } })); }))),
            this.discountSelectionState === DiscountSelectionState.Saved && !hasSavedDiscounts && (react_1.default.createElement(kaleidoscope_1.Alert, { heading: "Use discounts regularly?", alertType: kaleidoscope_1.AlertType.Info, alignment: kaleidoscope_1.AlertAlignment.Center }, "Add saved discounts below to reuse them and save time when creating quotes."))));
    };
    DiscountPanel.prototype.renderCustomDiscounts = function () {
        var _this = this;
        var _a;
        var _b = this.props, discountStore = _b.discountStore, telemetryHierarchy = _b.telemetryHierarchy;
        return (react_1.default.createElement("div", null,
            react_1.default.createElement(NumberInput_1.default, { label: "Discount amount", labelHidden: true, variant: kaleidoscope_1.TextInputVariant.Bordered, size: kaleidoscope_1.TextInputSize.Medium, value: discountStore.units, onChange: function (value) {
                    discountStore.setCustomDiscount(value, discountStore.type);
                    _this.quoteTelemetry.trackDiscountApplied(telemetryHierarchy, "one-off");
                }, type: kaleidoscope_1.TextInputType.Number, endElement: react_1.default.createElement(kaleidoscope_1.SegmentedControl, { label: "Discount type", labelHidden: true, size: kaleidoscope_1.SegmentedControlSize.Medium, onClickHandler: function (value) {
                        discountStore.setCustomDiscount(discountStore.units, value);
                    }, options: [
                        {
                            label: "%",
                            value: Types_1.DiscountType.Percent,
                        },
                        {
                            label: this.quoteCurrencyFormatter.getSymbol(),
                            value: Types_1.DiscountType.Fixed,
                        },
                    ], selectedValue: (_a = discountStore.type) !== null && _a !== void 0 ? _a : Types_1.DiscountType.Percent }) })));
    };
    DiscountPanel.prototype.render = function () {
        var _this = this;
        var savedDiscounts = this.discountService.getAllLiveDiscounts();
        var hasSavedDiscounts = savedDiscounts && savedDiscounts.length > 0;
        return (react_1.default.createElement("div", { className: "discount-panel" },
            react_1.default.createElement(kaleidoscope_1.SegmentedControl, { label: "Discount", onClickHandler: this.handleDiscountSelectionChange, options: [
                    {
                        label: "None",
                        value: DiscountSelectionState.None,
                    },
                    {
                        label: "Saved",
                        value: DiscountSelectionState.Saved,
                    },
                    {
                        label: "Custom",
                        value: DiscountSelectionState.Custom,
                    },
                ], selectedValue: this.discountSelectionState }),
            this.discountSelectionState === DiscountSelectionState.Saved && this.renderSavedDiscounts(),
            this.discountSelectionState === DiscountSelectionState.Custom && this.renderCustomDiscounts(),
            react_1.default.createElement(kaleidoscope_1.Button, { onClick: function () {
                    _this.discountEditor.show(_this.quoteCurrencyFormatter);
                }, type: kaleidoscope_1.ButtonType.Secondary, width: "full" },
                hasSavedDiscounts ? "Manage" : "Add",
                " discounts")));
    };
    var _a, _b, _c, _d;
    __decorate([
        (0, inversify_react_1.resolve)("quoteCurrencyFormatter"),
        __metadata("design:type", typeof (_a = typeof QuoteCurrencyFormatter_1.default !== "undefined" && QuoteCurrencyFormatter_1.default) === "function" ? _a : Object)
    ], DiscountPanel.prototype, "quoteCurrencyFormatter", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("discountService"),
        __metadata("design:type", typeof (_b = typeof Discount_service_1.default !== "undefined" && Discount_service_1.default) === "function" ? _b : Object)
    ], DiscountPanel.prototype, "discountService", void 0);
    __decorate([
        inversify_react_1.resolve,
        __metadata("design:type", typeof (_c = typeof DiscountEditor_1.DiscountEditor !== "undefined" && DiscountEditor_1.DiscountEditor) === "function" ? _c : Object)
    ], DiscountPanel.prototype, "discountEditor", void 0);
    __decorate([
        inversify_react_1.resolve,
        __metadata("design:type", typeof (_d = typeof QuoteTelemetry_1.QuoteTelemetry !== "undefined" && QuoteTelemetry_1.QuoteTelemetry) === "function" ? _d : Object)
    ], DiscountPanel.prototype, "quoteTelemetry", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], DiscountPanel.prototype, "discountSelectionState", void 0);
    DiscountPanel = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], DiscountPanel);
    return DiscountPanel;
}(react_1.Component));
exports.default = DiscountPanel;
